import { render, staticRenderFns } from "./AFrenchChristmas.vue?vue&type=template&id=3be0d059&scoped=true"
import script from "./AFrenchChristmas.vue?vue&type=script&lang=js"
export * from "./AFrenchChristmas.vue?vue&type=script&lang=js"
import style0 from "./AFrenchChristmas.vue?vue&type=style&index=0&id=3be0d059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0d059",
  null
  
)

export default component.exports